import React, { Fragment, useContext, useEffect, useRef, useState } from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Breadcrumb from '@components/Shared/Breadcrumb';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { AppSettings } from '@config/app-settings.js';
import useGetCategoriesList from '@hooks/INV/useGetCategoriesList';
import { type CategoriesModels } from '@store/INV/Categories/CategoriesModels';
import EditCategoryInv from './EditCategoryInv';
import AddCategoryInv from './AddCategoryInv';
import ModalComponent from '@components/Modal/ModalComponent';
import { Card, CardExpandToggler, CardHeader } from '@components/card/card';
import Loading from '@components/Shared/Loader/Loading';
import NoData from '@components/NoData/NoData';
import { usePermissions } from '@Helper/Permisstions/usePermissions';

const Index = () => {
  const { HasPermission } = usePermissions();
  const [categoryId, setCategoryId] = useState<any>(null);
  const { t, i18n } = useTranslation();
  // const { ChartAccountsId } = useParams();
  const [categoryDetails, setCategoryDetails] = useState<CategoriesModels | undefined>();
  const { CategoriesList: data, loading, error } = useGetCategoriesList();

  // تهيئة categoryDetails بأول عنصر عند تحميل البيانات
  useEffect(() => {
    if (data && data.length > 0) {
      const firstCategory = data.find(f => f.categoryId === null); // أول عنصر رئيسي
      if (firstCategory) {
        setCategoryDetails(firstCategory);
        setCategoryId(firstCategory.id);
      }
    }
  }, [data]); // يعمل عند تغيير data

  //#region context tree file-node.has-sub
  const context = useContext(AppSettings);
  useEffect(() => {
    const handleFileArrowClick = (event: any) => {
      event.preventDefault();
      const node = event.target.closest('.file-node.has-sub');
      if (node) {
        node.classList.toggle('expand');
      }
    };

    const handleFileInfoClick = (event: any) => {
      event.preventDefault();
      const node = event.target.closest('.file-node');
      if (node) {
        const fileInfoNodes = document.querySelectorAll('.file-node');
        fileInfoNodes.forEach(otherNode => {
          if (otherNode !== node) {
            otherNode.classList.remove('selected');
          }
        });
        node.classList.add('expand');
        node.classList.add('selected');
      }
    };

    const fileHasSubNodes = document.querySelectorAll('.file-node.has-sub');
    fileHasSubNodes.forEach(node => {
      const fileArrow = node.querySelector('.file-link > .file-arrow');
      fileArrow?.addEventListener('click', handleFileArrowClick);
    });

    const fileInfoNodes = document.querySelectorAll('.file-node');
    fileInfoNodes.forEach(node => {
      const fileInfo = node.querySelector('.file-link > .file-info');
      fileInfo?.addEventListener('click', handleFileInfoClick);
    });

    context.setAppContentFullHeight(true);

    return function cleanUp() {
      context.setAppContentFullHeight(false);
      fileHasSubNodes.forEach(node => {
        const fileArrow = node.querySelector('.file-link > .file-arrow');
        fileArrow?.removeEventListener('click', handleFileArrowClick);
      });
      fileInfoNodes.forEach(node => {
        const fileInfo = node.querySelector('.file-link > .file-info');
        fileInfo?.removeEventListener('click', handleFileInfoClick);
      });
    };
  }, [data, context]);

  //#endregion

  return (
    <>
      <div className='d-flex align-items-center'>
        <Breadcrumb
          BreadcrumbList={[
            {
              name: 'Home',
             link: ':moduleHome'
            },
            {
              name: 'Categories',
              link: null
            }
          ]}
          PageName='Categories'
        />

        <div className='ms-auto'>
          {HasPermission('INVAddCategories') && (
            <Link
              to=''
              className='btn me-1 btn-theme'
              data-bs-toggle='modal'
              data-bs-target='#modalAddCategoriesINV'
              onClick={() => setCategoryId(null)}
            >
              <i className='fa fa-plus-circle fa-fw me-1'></i>
              {t('AddMainCategory')}
            </Link>
          )}
        </div>
      </div>

      <div className='row'>
        <div className='col-lg-5'>
          <Loading loading={loading} error={error}>
            <Card className=''>
              <CardHeader className='d-flex justify-content-between align-items-center '>
                <span className=' fw-bold m-1'>{t('Categories')}</span>
                <CardExpandToggler />
              </CardHeader>

              {data.length > 0 ? (
                <>
                  <div className='file-manager-sidebar-content'>
                    <PerfectScrollbar className='h-100 p-2'>
                      <div className='file-tree  '>
                        {data
                          ?.filter(f => f.categoryId === null)
                          ?.map((tree, idx) => {
                            return (
                              <ItemTree
                                key={tree.id}
                                tree={tree}
                                setTreeDetails={setCategoryDetails}
                                setCategoryId={setCategoryId}
                              />
                            );
                          })}
                      </div>
                    </PerfectScrollbar>
                  </div>
                </>
              ) : (
                <NoData />
              )}
            </Card>
          </Loading>
        </div>

        <div className='col-lg-7'>{categoryDetails && <EditCategoryInv categoryDetails={categoryDetails} />}</div>
      </div>

      <ModalComponent title={t('AddCategory')} id='modalAddCategoriesINV' size='lg'>
        <AddCategoryInv CategoryId={categoryId} />
      </ModalComponent>
    </>
  );
};
export default Index;
//_______________________________________________________________________________________________

type PropsItemTree = {
  tree: CategoriesModels;
  setTreeDetails: React.Dispatch<CategoriesModels | undefined>;
  setCategoryId: React.Dispatch<React.SetStateAction<any>>;
};
const ItemTree: React.FC<PropsItemTree> = ({ tree, setTreeDetails, setCategoryId }) => {
  const { CategoriesList: data } = useGetCategoriesList();
  const { HasPermission } = usePermissions();

  const { i18n } = useTranslation();
  const linkRef = useRef<HTMLAnchorElement | null>(null);

  return (
    <Fragment key={tree.id}>
      <div className='d-flex justify-content-between p-1 border-1 border-start border-theme '>
        <div className={`file-node ${data?.filter(f => f.categoryId === tree?.id)?.length && 'has-sub'}`}>
          <Link to='' className='file-link'>
            <span className='file-arrow'></span>
            <span
              ref={linkRef}
              className='file-info ms-1'
              onClick={() => {
                setTreeDetails(tree);
                setCategoryId(tree.id);
              }}
            >
              <span className='file-icon'>
                <i className={` ${tree.icon ? tree.icon : ' bi bi-app fa-lg'} text-theme`}></i>
              </span>
              <span className='file-text fs-6'>{i18n.language === 'en' ? tree.name : tree.name2}</span>
            </span>
          </Link>

          <div className='file-tree'>
            {data
              ?.filter(node => node.categoryId === tree.id)
              ?.map((node, idx) => {
                return (
                  <ItemTree
                    key={node.id}
                    tree={node}
                    setTreeDetails={setTreeDetails}
                    // setCategoryId={node.id}
                    setCategoryId={setCategoryId}
                  />
                );
              })}
          </div>
        </div>
        <div className='pt-2'>
          <Link
            hidden={!HasPermission('INVAddSubCategories')}
            to=''
            data-bs-toggle='modal'
            data-bs-target='#modalAddCategoriesINV'
            className='pt-1 ms-4 text-theme'
            onClick={() => {
              linkRef?.current?.click();
              setCategoryId(tree.id);
            }}
          >
            <i className=' fa-lg fa-fw  fs-4 bi bi-plus-square-fill'></i>
          </Link>
        </div>
      </div>
    </Fragment>
  );
};
